/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type PrivacyPolicyResponse,
    PrivacyPolicyResponseFromJSON,
    PrivacyPolicyResponseToJSON,
} from '../models/PrivacyPolicyResponse';

/**
 * 
 */
export class PrivacyPolicyApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiPrivacyPolicyGet without sending the request
     */
    async apiPrivacyPolicyGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/privacy-policy`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiPrivacyPolicyGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrivacyPolicyResponse>> {
        const requestOptions = await this.apiPrivacyPolicyGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrivacyPolicyResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiPrivacyPolicyGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrivacyPolicyResponse> {
        const response = await this.apiPrivacyPolicyGetRaw(initOverrides);
        return await response.value();
    }

}
